__turbopack_context__.v({
  "container": "Menu-module-scss-module__3OPR9q__container",
});
